import BaseMesh from "./Base/BaseMesh";
import { vectorizeGenomicPosInd } from "../../helpers/vectorize";

function updateBufferUnary(buffAttr, { count, isAppend }) {
  const { step, buffer } = buffAttr;
  const { array } = buffer;
  const start = isAppend ? buffAttr.itemCount : 0;

  buffAttr.updateItemCount(count, isAppend);

  return (i, y1, y2) => {
    const base = (start + i) * step;
    array[base] = y1;
    array[base + 1] = y2;
  };
}

class AreaMesh extends BaseMesh {
  constructor(uniforms, conf) {
    const idxPattern = [0, 1, 2, 2, 1, 3];
    const verticesPerItem = 2;
    const idxPerItem = 6;
    const idxOffset = -2;
    super({
      uniforms,
      conf,
      idxOffset,
      verticesPerItem,
      idxPattern,
      idxPerItem,
    });
  }

  updateX({ count, isAppend }) {
    const posXBuffer = this.attrs.posX;
    const { step, buffer } = posXBuffer;
    const { array } = buffer;
    const start = isAppend ? posXBuffer.itemCount : 0;
    posXBuffer.updateItemCount(count, isAppend);

    return (i, x0, x1) => {
      const base = (start + i) * step;
      vectorizeGenomicPosInd(array, base + 0, x0);
      vectorizeGenomicPosInd(array, base + 2, x1);
    };
  }

  updateOffset({ count, isAppend }) {
    const offsetBuf = this.attrs.offset;
    const { step, buffer } = offsetBuf;
    const { array } = buffer;
    const start = isAppend ? offsetBuf.itemCount : 0;
    offsetBuf.updateItemCount(count, isAppend);

    return (i, o1, o2) => {
      const base = (start + i) * step;
      array[base + 0] = o1;
      array[base + 1] = o2;
    };
  }

  updateRgba(args) {
    return updateBufferUnary(this.attrs.rgbaCode, args);
  }

  updateY(args) {
    return updateBufferUnary(this.attrs.posY, args);
  }

  updatePosYInd(args) {
    return updateBufferUnary(this.attrs.posYInd, args);
  }

  updateTextureCoordsInd(args) {
    return updateBufferUnary(this.attrs.textureCoordsInd, args);
  }
}

export default AreaMesh;
